import GhostTransactionCard from "./GhostTransactionCard";
import GhostBar from "./GhostBar";

const GhostTransactionsCarousel = ({ count = 2, showPagination = true }) => {
  return (
    <div className="scc-body" style={{ overflow: "hidden" }}>
      <div
        className="scc-body-wrapper"
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px", // Must match the gap in your BaseCarousel CSS
          width: "max-content", // Important: allows content to exceed 100% width
        }}
      >
        {Array.from({ length: count }).map((_, i) => (
          <GhostTransactionCard />
        ))}
      </div>
    </div>
  );
};

export default GhostTransactionsCarousel;
